import { Box, Typography } from '@mui/material';

import { DISABLED } from 'src/utils/constants';

import logo from './infosync-logo.png';

export function LogoTitle() {
    return (
        <>
            {
                DISABLED &&
                <Box alt="logo" component="img" src={logo} sx={{ width: 100, height: 40, pb: 1 }} />
            }
            {
                true && (
                    <Typography variant="subtitle1" sx={{ mt: 0.5, ml: 1, color: 'text.primary' }}>
                        InfoSync
                    </Typography>
                )
            }
        </>
    )
}